

// Mock data for Automation Builder
export const mockAutomations = [
  {
    id: "auto-001",
    name: "Lead Follow-Up",
    object: "Lead",
    trigger: "on update",
    status: "Active",
    createdAt: "2025-07-10T09:15:00Z",
    modifiedAt: "2025-07-12T14:22:00Z",
    conditions: [
      {
        field: "status",
        operator: "equals",
        value: "Qualified",
        logic: "AND"
      }
    ],
    actions: [
      {
        type: "Create Task",
        parameters: {
          subject: "Follow up with qualified lead",
          assignedTo: "Sales Team",
          dueDate: "3 days"
        }
      }
    ]
  },
  {
    id: "auto-002",
    name: "Invoice Reminder",
    object: "Invoice",
    trigger: "on create",
    status: "Inactive",
    createdAt: "2025-07-05T11:00:00Z",
    modifiedAt: "2025-07-08T16:45:00Z",
    conditions: [
      {
        field: "amount",
        operator: ">",
        value: "1000",
        logic: "AND"
      }
    ],
    actions: [
      {
        type: "Send Email",
        parameters: {
          template: "Invoice Reminder",
          to: "customer",
          delay: "1 day"
        }
      }
    ]
  },
  {
    id: "auto-003",
    name: "Deal Closure Notification",
    object: "Deal",
    trigger: "on update",
    status: "Active",
    createdAt: "2025-07-01T08:30:00Z",
    modifiedAt: "2025-07-10T12:15:00Z",
    conditions: [
      {
        field: "stage",
        operator: "equals",
        value: "Closed Won",
        logic: "AND"
      }
    ],
    actions: [
      {
        type: "Update Field",
        parameters: {
          field: "celebration_sent",
          value: "true"
        }
      },
      {
        type: "Send Email",
        parameters: {
          template: "Deal Celebration",
          to: "owner",
          delay: "immediate"
        }
      }
    ]
  },
  {
    id: "auto-004",
    name: "Account Onboarding",
    object: "Account",
    trigger: "on create",
    status: "Active",
    createdAt: "2025-06-28T14:20:00Z",
    modifiedAt: "2025-07-02T09:45:00Z",
    conditions: [
      {
        field: "type",
        operator: "equals",
        value: "Customer",
        logic: "AND"
      }
    ],
    actions: [
      {
        type: "Create Task",
        parameters: {
          subject: "Schedule onboarding call",
          assignedTo: "Customer Success",
          dueDate: "2 days"
        }
      }
    ]
  }
];

export const mockObjects = [
  { id: "Lead", name: "Lead", icon: "assignment" },
  { id: "Deal", name: "Deal", icon: "trending_up" },
  { id: "Account", name: "Account", icon: "business" },
  { id: "Contact", name: "Contact", icon: "person" },
  { id: "Quote", name: "Quote", icon: "request_quote" },
  { id: "Order", name: "Order", icon: "shopping_cart" },
  { id: "Invoice", name: "Invoice", icon: "receipt" },
  { id: "Echo", name: "Echo", icon: "record_voice_over" },
  { id: "travel_orders", name: "Travel Orders", icon: "flight_takeoff" }
];

export const mockTriggers = [
  { id: "On Create", name: "On Create" },
  { id: "On Update", name: "On Update" },
  { id: "On Delete", name: "On Delete" }
];

export const mockFields = {
  Lead: [
    { id: "status", name: "Status", type: "picklist", options: ["New", "Working", "Qualified", "Unqualified"] },
    { id: "source", name: "Source", type: "picklist", options: ["Website", "Phone", "Email", "Referral"] },
    { id: "rating", name: "Rating", type: "picklist", options: ["Hot", "Warm", "Cold"] },
    { id: "company", name: "Company", type: "text" },
    { id: "email", name: "Email", type: "email" },
    { id: "phone", name: "Phone", type: "phone" },
    { id: "ownerId", name: "Owner", type: "lookup" },
    { id: "createdDate", name: "Created Date", type: "date" }
  ],
  Deal: [
    { id: "stage", name: "Stage", type: "picklist", options: ["Prospecting", "Qualification", "Proposal", "Negotiation", "Closed Won", "Closed Lost"] },
    { id: "amount", name: "Amount", type: "currency" },
    { id: "probability", name: "Probability", type: "percent" },
    { id: "closeDate", name: "Close Date", type: "date" },
    { id: "type", name: "Type", type: "picklist", options: ["New Business", "Existing Business", "Renewal"] },
    { id: "ownerId", name: "Owner", type: "lookup" },
    { id: "accountId", name: "Account", type: "lookup" }
  ],
  Account: [
    { id: "type", name: "Type", type: "picklist", options: ["Customer", "Prospect", "Partner", "Competitor"] },
    { id: "industry", name: "Industry", type: "picklist", options: ["Technology", "Healthcare", "Finance", "Manufacturing"] },
    { id: "revenue", name: "Annual Revenue", type: "currency" },
    { id: "employees", name: "Employees", type: "number" },
    { id: "rating", name: "Rating", type: "picklist", options: ["Hot", "Warm", "Cold"] },
    { id: "ownerId", name: "Owner", type: "lookup" }
  ],
  Contact: [
    { id: "title", name: "Title", type: "text" },
    { id: "department", name: "Department", type: "text" },
    { id: "email", name: "Email", type: "email" },
    { id: "phone", name: "Phone", type: "phone" },
    { id: "accountId", name: "Account", type: "lookup" },
    { id: "ownerId", name: "Owner", type: "lookup" }
  ],
  Quote: [
    { id: "status", name: "Status", type: "picklist", options: ["Draft", "Sent", "Accepted", "Rejected"] },
    { id: "amount", name: "Amount", type: "currency" },
    { id: "validUntil", name: "Valid Until", type: "date" },
    { id: "ownerId", name: "Owner", type: "lookup" }
  ],
  Order: [
    { id: "status", name: "Status", type: "picklist", options: ["Draft", "In Progress", "Completed", "Cancelled"] },
    { id: "amount", name: "Amount", type: "currency" },
    { id: "orderDate", name: "Order Date", type: "date" },
    { id: "ownerId", name: "Owner", type: "lookup" }
  ],
  Invoice: [
    { id: "status", name: "Status", type: "picklist", options: ["Draft", "Sent", "Paid", "Overdue"] },
    { id: "amount", name: "Amount", type: "currency" },
    { id: "dueDate", name: "Due Date", type: "date" },
    { id: "ownerId", name: "Owner", type: "lookup" }
  ],
  Echo: [
    { id: "status", name: "Status", type: "picklist", options: ["Active", "Inactive"] },
    { id: "type", name: "Type", type: "text" },
    { id: "ownerId", name: "Owner", type: "lookup" }
  ]
};

export const mockOperators = [
  { id: "equals", name: "equals", types: ["text", "picklist", "lookup"] },
  { id: "not_equals", name: "not equals", types: ["text", "picklist", "lookup"] },
  { id: "contains", name: "contains", types: ["text", "email"] },
  { id: "does_not_contain", name: "does not contain", types: ["text", "email"] },
  { id: "greater_than", name: ">", types: ["currency", "number", "percent", "date"] },
  { id: "greater_than_equal", name: ">=", types: ["currency", "number", "percent", "date"] },
  { id: "less_than", name: "<", types: ["currency", "number", "percent", "date"] },
  { id: "less_than_equal", name: "<=", types: ["currency", "number", "percent", "date"] },
  { id: "is_empty", name: "is empty", types: ["text", "email", "phone"] },
  { id: "is_not_empty", name: "is not empty", types: ["text", "email", "phone"] }
];

export const mockActionTypes = [
  { 
    id: "Update Field", 
    name: "Update Field",
    description: "Update a field value on the record",
    icon: "edit"
  },
  { 
    id: "Create Task", 
    name: "Create Task",
    description: "Create a new task",
    icon: "task"
  },
  { 
    id: "Send Email", 
    name: "Send Email",
    description: "Send an email using a template",
    icon: "email"
  },
  { 
    id: "Create Record", 
    name: "Create Record",
    description: "Create a new record",
    icon: "add"
  },
  { 
    id: "Update Related Record", 
    name: "Update Related Record",
    description: "Update a related record",
    icon: "link"
  }
];

export const mockEmailTemplates = [
  { id: "welcome", name: "Welcome Email" },
  { id: "followup", name: "Follow-up Email" },
  { id: "reminder", name: "Reminder Email" },
  { id: "invoice", name: "Invoice Reminder" },
  { id: "celebration", name: "Deal Celebration" },
  { id: "onboarding", name: "Account Onboarding" }
];

export const mockUsers = [
  { id: "user-001", name: "John Doe", email: "john@company.com" },
  { id: "user-002", name: "Jane Smith", email: "jane@company.com" },
  { id: "user-003", name: "Mike Johnson", email: "mike@company.com" },
  { id: "sales-team", name: "Sales Team", email: "sales@company.com" },
  { id: "customer-success", name: "Customer Success", email: "cs@company.com" }
];

export const mockLogs = {
  "auto-001": [
    {
      id: "log-001",
      automationId: "auto-001",
      timestamp: "2025-07-12T14:22:00Z",
      recordId: "lead-123",
      recordName: "John Doe - ABC Corp",
      status: "Success",
      message: "Task created successfully for qualified lead",
      executionTime: "0.5s",
      details: {
        triggeredBy: "Status changed from 'Working' to 'Qualified'",
        actionsExecuted: ["Create Task: Follow up with qualified lead"]
      }
    },
    {
      id: "log-002",
      automationId: "auto-001",
      timestamp: "2025-07-11T10:15:00Z",
      recordId: "lead-124",
      recordName: "Sarah Wilson - XYZ Inc",
      status: "Success",
      message: "Task created successfully for qualified lead",
      executionTime: "0.3s",
      details: {
        triggeredBy: "Status changed from 'New' to 'Qualified'",
        actionsExecuted: ["Create Task: Follow up with qualified lead"]
      }
    },
    {
      id: "log-003",
      automationId: "auto-001",
      timestamp: "2025-07-10T16:30:00Z",
      recordId: "lead-125",
      recordName: "Michael Brown - DEF Ltd",
      status: "Failed",
      message: "Failed to create task: Invalid assignee",
      executionTime: "1.2s",
      details: {
        triggeredBy: "Status changed from 'Working' to 'Qualified'",
        error: "Assignee 'Sales Team' not found"
      }
    }
  ],
  "auto-002": [
    {
      id: "log-004",
      automationId: "auto-002",
      timestamp: "2025-07-08T11:00:00Z",
      recordId: "invoice-001",
      recordName: "Invoice #INV-2025-001",
      status: "Success",
      message: "Email reminder sent successfully",
      executionTime: "0.8s",
      details: {
        triggeredBy: "Invoice created with amount $1,500",
        actionsExecuted: ["Send Email: Invoice Reminder to customer"]
      }
    }
  ],
  "auto-003": [
    {
      id: "log-005",
      automationId: "auto-003",
      timestamp: "2025-07-10T12:15:00Z",
      recordId: "deal-001",
      recordName: "ABC Corp - Software License",
      status: "Success",
      message: "Deal closure notification sent",
      executionTime: "0.6s",
      details: {
        triggeredBy: "Deal stage changed to 'Closed Won'",
        actionsExecuted: ["Update Field: celebration_sent = true", "Send Email: Deal Celebration"]
      }
    }
  ],
  "auto-004": [
    {
      id: "log-006",
      automationId: "auto-004",
      timestamp: "2025-07-02T09:45:00Z",
      recordId: "account-001",
      recordName: "New Customer Corp",
      status: "Success",
      message: "Onboarding task created",
      executionTime: "0.4s",
      details: {
        triggeredBy: "Account created with type 'Customer'",
        actionsExecuted: ["Create Task: Schedule onboarding call"]
      }
    }
  ]
};

export const mockLogStats = {
  totalExecutions: 156,
  successRate: 94.2,
  avgExecutionTime: "0.6s",
  recentExecutions: [
    { date: "2025-07-12", count: 8, success: 7 },
    { date: "2025-07-11", count: 12, success: 11 },
    { date: "2025-07-10", count: 15, success: 14 },
    { date: "2025-07-09", count: 6, success: 6 },
    { date: "2025-07-08", count: 9, success: 8 }
  ]
}; 